
























import { Prop, Component, Vue } from "vue-property-decorator";
import Action from "@/models/action";
import VToolbar from "../../../components/VToolbar.vue";
import TemplateSearchBar from "../components/TemplateSearchBar.vue";
import { Construction } from "../../api/construction-api";
export interface IConstructionListItem {
  id: string;
  name: string;
  shortName: string;
  serviceTaskType: string;
}
@Component({
  components: {
    VToolbar,
    TemplateSearchBar
  }
})
export default class ConstructionList extends Vue {
  @Prop({ default: () => [] }) actions!: Action[];
  @Prop({ default: () => [] }) companies!: Construction[];
  @Prop({ default: () => [] }) construction!: Construction[];

  fields = [
    { key: "name", label: "工事名", sortable: true },
    { key: "shortName", label: "工事名短縮", sortable: true },
    { key: "serviceTaskType", label: "工程表名", sortable: true }
  ];
}
